import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { default as config } from '../../../constants/constants';

interface UploadResponse {
  status?: 'successful' | 'failed';
  message?: string;
}

export const postPdf = async (
  formData: FormData,
  podcastId: string,
  feedUrl: string,
  token: string
): Promise<AxiosResponse<UploadResponse>> => {
  const options: AxiosRequestConfig = {
    method: 'POST',
    headers: {
      'X-Firebase-Auth': token,
      'Content-Type': 'multipart/form-data'
    },
    url: `${config.serverURL}/summary/upload?feedUrl=${feedUrl}&podcastId=${podcastId}`,
    timeout: 30000,
    data: formData
  };

  return axios(options);
};
